import { render, staticRenderFns } from "./fullscreen-dialog.vue?vue&type=template&id=502e8307&scoped=true"
import script from "./fullscreen-dialog.vue?vue&type=script&lang=js"
export * from "./fullscreen-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e8307",
  null
  
)

export default component.exports